<template lang="pug">
  .target.targets
    .toolbar
      .line.toolbar__line(style="justify-content: end")
        .actions-panel.view-panel.view-panel_divide
          e-button-add.actions-panel__button.btn-text.button.button_usual(
            @click="showYearModal = true"
            label="Добавить столбец"
            btnDefaultClass=" "
          )
    e-modal(
      v-if="showYearModal"
      title="Выбор года"
      @close="showYearModal = false"
      @confirm="addYearColumn"
    )
      slot
        e-form(:formValidator="formValidator")
          e-form-group(
            name="newYear"
            inputType="select"
            label="Год"
            :model="fields"
            :required="true"
            tabView="tab1"
            :options="yearsOptions"
          )
    .content
      .table.overflow-hidden
        .theader-wrapper
          table(cellspacing="0" style="width: 100%" ref="tableHeader")
            colgroup
              col(v-for="(header, index) in tableHeaders" :key="index" :width="header.width")
            thead
              tr
                th.table__th.semibold(v-for="header in tableHeaders" :key="header.key" :colspan="header.colspan" :rowspan="header.rowspan")
                  .th-block
                    span {{ header.label }}
                    e-button-delete(
                      v-if="header.deletable"
                      @click="removeYearColumn(header.year)"
                    ).reset-btn.button.button_delete.button_small.button_icon
                    e-button-edit(v-if="header.deletable && !header.isEditing" @click="enableEditing(header.key)") Редактировать
                    button.button.button_usual(v-if="header.deletable && header.isEditing" @click="disableEditing(header.key)") Рассчитать

        e-perfect-scrollbar(
          ref="tablePS"
          :emitTypes="['vue']"
          @ps-scroll-x="scrollHandler($event.event)"
          :config="{suppressScrollY: false, suppressScrollX: false}"
        )
          .tbody-wrapper(:style="{'max-height':'calc(100vh - 375px)'}")
            table(cellspacing="0" style="width: 100%")
              colgroup
                col(v-for="(header, index) in tableHeaders" :key="index" :width="header.width")
              tbody(ref="tableBody")
                tr(v-for="(row, rowIndex) in tableData" :key="rowIndex")
                  td.table__td(v-for="(header, colIndex) in tableHeaders" :key="colIndex")
                    div(v-if="colIndex === 0") {{ rowIndex + 1 }}
                    div(v-if="colIndex === 1") {{ row.name }}
                    div(v-if="colIndex === 2") {{ row.unit }}
                    span(v-if="colIndex > 2")
                      span(v-if="!row._isEdit[header.key] || !header.isEditing")
                        span(
                          @dblclick="isEditable(colIndex, row) && enableEditing(header.key, row)"
                          :title="isEditable(colIndex, row) ? 'Двойной клик для редактирования' : ''"
                        ) {{ formatNumber(row[header.key], row.key) || '-' }}
                      div(v-else)
                        input.input(
                          type="number"
                          :step="getInputStep(header.key)"
                          v-model="row[header.key]"
                        )
</template>

<script>
import { map, msn } from '@/api/api-endpoints'
import year from '@/utils/year'
import formBaseMixin from '@/components/form/form-base-mixin'

export default {
  name: 'estimatedQuantityTab',
  mixins: [formBaseMixin],
  props: {
    tko_operator_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      fields: {
        newYear: year.getCurrentYear(),
      },
      showYearModal: false,
      isLoadedFromBackendId: null,
      tableHeaders: [
        { key: 'number', label: '№ п/п', width: 40 },
        { key: 'name', label: 'Наименование', width: 300 },
        { key: 'unit', label: 'Ед. измерения', width: 100 },
      ],
      tableData: [
        {
          name: 'Количество действующих контейнеров',
          unit: 'шт.',
          key: 'active_containers_count',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Количество действующих бункеров',
          unit: 'шт.',
          key: 'active_bunkers_count',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Количество закупленных контейнеров',
          unit: 'шт.',
          key: 'purchased_conditional_containers_count',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Количество закупленных бункеров',
          unit: 'шт.',
          key: 'purchased_conditional_bunkers_count',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Минимальное количество условных контейнеров для сбора нормативного количества ТКО (1.1 м3)',
          unit: 'шт.',
          key: 'minimum_conditional_containers_count',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Количество условных бункеров для сбора КГО шт. (8 м3)',
          unit: 'шт.',
          key: 'minimum_conditional_bunkers_count',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Стоимость 1 контейнера',
          unit: 'руб.',
          key: 'container_cost',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Стоимость 1 бункера',
          unit: 'руб.',
          key: 'bunker_cost',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Необходимая валовая выручка регионального оператора',
          unit: 'руб.',
          key: 'required_gross_revenue',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: '% от НВВ РО',
          unit: '%',
          key: 'required_gross_revenue_percent',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Требуемое количество контейнеров',
          unit: 'шт.',
          key: 'required_containers_count',
          _isEdit: {},
        },
        {
          name: 'Требуемое количество бункеров',
          unit: 'шт.',
          key: 'required_bunkers_count',
          _isEdit: {},
        },
        {
          name: 'Максимальные допустимые затраты на закупку контейнеров и бункеров',
          unit: 'руб.',
          key: 'maximum_allowable_costs',
          _isEdit: {},
        },
        {
          name: 'Расчетное количество контейнеров в рамках бюджета',
          unit: 'шт.',
          key: 'estimated_containers_count',
          _isEdit: {},
        },
        {
          name: 'Стоимость закупки расчетного количества контейнеров',
          unit: 'руб.',
          key: 'estimated_containers_cost',
          _isEdit: {},
        },
        {
          name: 'Расчетное количество бункеров в рамках бюджета',
          unit: 'шт.',
          key: 'estimated_bunkers_count',
          _isEdit: {},
        },
        {
          name: 'Стоимость закупки расчетного количества бункеров',
          unit: 'руб.',
          key: 'estimated_bunkers_cost',
          _isEdit: {},
        },
      ],
    }
  },
  computed: {
    yearsOptions() {
      const yearsInTable = this.tableHeaders
        .filter((header) => header.year)
        .map((header) => header.year)
      return this.$store.state.years
        .filter((year) => !yearsInTable.includes(year))
        .map((year) => ({ id: year, name: year }))
    },
  },
  methods: {
    async disableEditing(headerKey) {
      let hasEmptyFields = false

      this.tableData.forEach((row) => {
        if (
          row.isEditable &&
          (row[headerKey] === '' ||
            row[headerKey] === undefined ||
            row[headerKey] === null)
        ) {
          hasEmptyFields = true
        }
      })

      if (hasEmptyFields) {
        this.$e.errorBox('Заполните обязательные поля!')
        return
      }
      this.tableHeaders = this.tableHeaders.map((header) => {
        if (header.key === headerKey) {
          header.isEditing = false
        }
        return header
      })
      const isLoadedFromBackend = this.tableHeaders.find(
        (el) => el.key === headerKey
      )?.id
      const id = isLoadedFromBackend
        ? this.tableHeaders.find((el) => el.key === headerKey)?.id
        : this.isLoadedFromBackendId
      try {
        if (isLoadedFromBackend || this.isLoadedFromBackendId) {
          await this.patchData(headerKey, id).then(() => this.fetchData())
        } else {
          await this.postData(headerKey, id).then(() => this.fetchData())
        }
      } catch (e) {
        console.error(e)
      }

      this.tableData.forEach((row) => {
        if (row.isEditable) {
          this.$set(row._isEdit, headerKey, false)
        }
      })
    },
    async postData(headerKey) {
      const dataToPost = this.tableData.reduce((acc, row) => {
        if (row[headerKey] !== '' && row[headerKey] !== undefined) {
          acc[row.key] = row[headerKey]
        }
        return acc
      }, {})

      const keyForDelete = [
        'estimated_bunkers_cost',
        'estimated_bunkers_count',
        'estimated_containers_cost',
        'estimated_containers_count',
        'maximum_allowable_costs',
        'required_bunkers_count',
        'required_containers_count',
      ]
      keyForDelete.forEach((key) => {
        if (key in dataToPost) {
          delete dataToPost[key]
        }
      })
      dataToPost.year = headerKey.match(/\d{4}/)[0]
      dataToPost.tko_operator_id = this.tko_operator_id

      try {
        const response = await this.$store.dispatch('createModel', {
          url: msn.createEstimatedQuantity(),
          data: dataToPost,
        })
        this.tableData.forEach((row) => {
          if (row.key in response.data) {
            this.$set(row, headerKey, response.data[row.key])
          }
        })
        this.isLoadedFromBackendId = response.data.id
      } catch (error) {
        throw new Error('Ошибка при PATCH-запросе')
      }
    },
    async patchData(headerKey, id) {
      const dataToPatch = this.tableData.reduce((acc, row) => {
        if (row[headerKey] !== '' && row[headerKey] !== undefined) {
          acc[row.key] = row[headerKey]
        }
        return acc
      }, {})

      const keyForDelete = [
        'estimated_bunkers_cost',
        'estimated_bunkers_count',
        'estimated_containers_cost',
        'estimated_containers_count',
        'maximum_allowable_costs',
        'required_bunkers_count',
        'required_containers_count',
      ]
      keyForDelete.forEach((key) => {
        if (key in dataToPatch) {
          delete dataToPatch[key]
        }
      })

      try {
        const response = await this.$store.dispatch('updateModel', {
          url: msn.estimatedQuantityPatch(id),
          data: dataToPatch,
        })
        this.tableData.forEach((row) => {
          if (row.key in response.data) {
            this.$set(row, headerKey, response.data[row.key])
          }
        })
      } catch (e) {
        console.error(e)
      }
    },
    async fetchData() {
      try {
        const response = await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getEndpoint(),
        })
        const data = response.data.data
        data.forEach((item) => {
          const yearKey = `year_${item.year}`
          if (!this.tableHeaders.find(({ key }) => key === yearKey)) {
            this.tableHeaders.push({
              key: yearKey,
              label: item.year,
              width: 150,
              year: item.year,
              deletable: true,
              isEditing: false,
              id: item.id,
            })
          }
          this.tableData.forEach((row) => {
            this.$set(row, yearKey, item[row.key])
            this.$set(row._isEdit, yearKey, false)
          })
        })

        this.tableHeaders.sort((a, b) => {
          if (a.year && b.year) {
            return a.year - b.year
          }
          return 0
        })
      } catch (e) {
        console.error(e)
      }
    },
    getEndpoint() {
      const tkoOperatorId = this.tko_operator_id
      return msn.estimatedQuantity({
        query: { tko_operator_id: tkoOperatorId, year: this.fields.newYear },
      })
    },
    addYearColumn() {
      const yearKey = `year_${this.fields.newYear}`
      this.tableHeaders.push({
        key: yearKey,
        label: this.fields.newYear,
        width: 150,
        year: this.fields.newYear,
        deletable: true,
        isEditing: false,
      })

      this.tableHeaders.sort((a, b) => {
        if (a.year && b.year) {
          return a.year - b.year
        }
        return 0
      })

      this.tableData.forEach((row) => {
        row[yearKey] = ''
        this.$set(row._isEdit, yearKey, false)
      })
      this.showYearModal = false
    },
    async removeYearColumn(year) {
      const headerToDelete = this.tableHeaders.find(
        (header) => header.year === year
      )

      if (!headerToDelete) {
        return
      }
      const id = headerToDelete.id
      if (id) {
        try {
          await this.$store.dispatch('deleteModel', {
            url: msn.estimatedQuantityDelete(id),
          })
        } catch (e) {
          console.error(e)
        }
      }
      this.tableHeaders = this.tableHeaders.filter(
        (header) => header.year !== year
      )
      this.tableData.forEach((row) => {
        this.$delete(row, `year_${year}`)
        this.$delete(row._isEdit, `year_${year}`)
      })
    },
    scrollHandler(event) {
      let { scrollLeft = 0 } = event.target
      this.$refs.tableHeader.style.marginLeft = `-${scrollLeft}px`
    },
    onSelectYear(year) {
      this.newYear = year
    },
    getYears() {
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint: map.yearFuture(),
        })
        .then((r) => {
          let _yearsOptions = []
          r.data.year.forEach((i) => {
            _yearsOptions.push(i.year)
          })
          this.$store.commit('setYears', _yearsOptions)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    isEditable(colIndex, row) {
      return colIndex > 2 && row.isEditable
    },
    enableEditing(columnKey) {
      this.tableHeaders = this.tableHeaders.map((header) => {
        if (header.key === columnKey) {
          header.isEditing = true
        }
        return header
      })

      this.tableData.forEach((row) => {
        if (row.isEditable) {
          this.$set(row._isEdit, columnKey, true)
        }
      })
    },
    formatNumber(value, key) {
      if (value === null || value === undefined) return '-'

      const integerKeys = [
        'active_containers_count',
        'active_bunkers_count',
        'purchased_conditional_containers_count',
        'purchased_conditional_bunkers_count',
        'minimum_conditional_containers_count',
        'minimum_conditional_bunkers_count',
        'required_containers_count',
        'required_bunkers_count',
        'estimated_containers_count',
        'estimated_bunkers_count',
      ]
      if (integerKeys.includes(key)) {
        return Number(Number(value).toFixed(0)).toLocaleString()
      } else {
        return Number(Number(value).toFixed(2)).toLocaleString()
      }
    },
    getInputStep(key) {
      const doubleKeys = [
        'container_cost',
        'bunker_cost',
        'required_gross_revenue',
        'required_gross_revenue_percent',
      ]
      return doubleKeys.includes(key) ? 'any' : '1'
    },
  },
  mounted() {
    if (this.tko_operator_id) {
      this.fetchData()
    } else {
      this.$watch('tko_operator_id', (newVal) => {
        if (newVal) {
          this.fetchData()
        }
      })
    }
    this.getYears()
  },
}
</script>
<style scoped lang="scss">
.table__td {
  padding: 15px 10px;
  background-color: #fff;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.th-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  gap: 5px;
  box-sizing: border-box;
}
</style>
